import { render } from "./HeaderChatDropdown.vue?vue&type=template&id=c467dd7a&scoped=true"
import script from "./HeaderChatDropdown.vue?vue&type=script&lang=js"
export * from "./HeaderChatDropdown.vue?vue&type=script&lang=js"

import "./HeaderChatDropdown.vue?vue&type=style&index=0&id=c467dd7a&scoped=true&lang=css"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c467dd7a"]])

export default __exports__